import { roundNumberToTwoDecimals } from '../../../../design-system/components/BarChart/utils';
import { BarChartTooltipItem } from '../../../../design-system/components/BarChart/BarChartTooltip';
import { separateEveryThousandByComma } from '../../../../lib/numbers';

type BuildBarChartTooltipSurveyRangedItemsType = {
  range: string;
  sum: number;
  percentage: number;
};

export const buildBarChartTooltipSurveyRangedItems = ({
  range,
  sum,
  percentage,
}: BuildBarChartTooltipSurveyRangedItemsType): BarChartTooltipItem[] => {
  return [
    {
      label: 'Responses in',
      value: range,
    },
    {
      label: 'Number of responses',
      value: typeof sum === 'number' ? separateEveryThousandByComma(sum) : '',
    },
    {
      label: 'Selected cohort size',
      value: `${roundNumberToTwoDecimals(percentage)}%`,
    },
  ];
};
